import './App.css';
import React, { useContext, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

import TransitionContext from './context/TransitionContext';

export default function App() {
    const main = useRef();
    const { completed } = useContext(TransitionContext);
    const scrollTween = useRef();
    const snapTriggers = useRef([]);
    const { contextSafe } = useGSAP(
        () => {
            if (!completed) return;
            let panels = gsap.utils.toArray('.panel'),
                scrollStarts = [0],
                snapScroll = value => value; // for converting a pixel-based scroll value to the closest panel scroll position

            // create a ScrollTrigger for each panel that's only concerned about figuring out when its top hits the top of the viewport. We'll use the "start" of that ScrollTrigger to figure out snapping positions.
            panels.forEach((panel, i) => {
                snapTriggers.current[i] = ScrollTrigger.create({
                    trigger: panel,
                    start: "top top"
                });
            });

            // once all the triggers have calculated their start/end, create the snap function that'll accept an overall progress value for the overall page, and then return the closest panel snapping spot based on the direction of scroll
            ScrollTrigger.addEventListener("refresh", () => {
                scrollStarts = snapTriggers.current.map(trigger => trigger.start); // build an Array with just the starting positions where each panel hits the top of the viewport
                snapScroll = ScrollTrigger.snapDirectional(scrollStarts); // get a function that we can feed a pixel-based scroll value to and a direction, and then it'll spit back the closest snap position (in pixels)
            });

            ScrollTrigger.observe({
                type: "wheel,touch",
                onChangeY(self) {
                    if (!scrollTween.current) {
                        // find the closest snapping spot based on the direction of scroll
                        let scroll = snapScroll(self.scrollY() + self.deltaY, self.deltaY > 0 ? 1 : -1);
                        goToSection(scrollStarts.indexOf(scroll)); // scroll to the index of the associated panel
                    }
                }
            })

            ScrollTrigger.refresh();
        },
        {
            dependencies: [completed],
            scope: main,
            revertOnUpdate: true,
        }
    );

    const goToSection = contextSafe((i) => {
        console.log("scroll to", i);
        scrollTween.current = gsap.to(window, {
            scrollTo: { y: snapTriggers.current[i].start, autoKill: false },
            duration: 1,
            onComplete: () => (scrollTween.current = null),
            overwrite: true
        });
    });

    return (
        <main ref={main}>
            <section className="description panel light">
                <div>
                    <h1>Layered pinning</h1>
                    <p>Use pinning to layer panels on top of each other as you scroll.</p>
                    <div className="scroll-down">
                        Scroll down<div className="arrow"></div>
                    </div>
                </div>
            </section>
            <section className="panel dark">ONE</section>
            <section className="panel purple">TWO</section>
            <section className="panel orange">THREE</section>
            <section className="panel red">FOUR</section>
        </main>
    );
}

